module.exports = __webpack_public_path__ + "img/user-info-icon.e398bdd2.png";